import React, { useEffect, useState } from "react";
import { Card, Table, Button, Row, Col, Form, Image, Pagination } from '@themesberg/react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import api from "../../utils/api";
import Swal from "sweetalert2";
import { format } from "date-fns";
import defaultIcon from "./../../assets/img/brand/logo2.png";

export default function SubscriptionList() {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/user-subscriptions', { params: { page, perPage, search } });


      if (!data.error) {
        setItems(data.data);
        setTotal(data.total);
        /* debugger;
        console.log(items); */

      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  useEffect(() => { fetchData(); }, [page, perPage]);

  const handleView = async (id) => {
    try {
      const { data } = await api.get(`/user-subscriptions/${id}`);
      const n = data.data || {};
      const imgUri = n.user?.user_images?.[0]?.uri || "";
      const firstImage = imgUri
        ? (imgUri.startsWith("http") ? imgUri : `/uploads/${imgUri}`)
        : defaultIcon;
      // const firstImage = n.user?.user_images?.[0]?.uri || defaultIcon;
      const sub = n?.subscription_response || null;

      const contentHtml = `
  <div style="
    text-align:left;
    font-family:Inter, Arial, sans-serif;
    color:#2d2d2d;
    font-size:14px;
    line-height:1.5;
  ">

    <!-- Header Section -->
    <div style="
      display:flex;
      gap:15px;
      margin-bottom:20px;
      padding:15px;
      border-radius:10px;
      background:#f9fafb;
      border:1px solid #e5e7eb;
      align-items:center;
    ">
      ${firstImage ? `
  <img src="${firstImage}" 
    onerror="this.onerror=null; this.src='${defaultIcon}'"
    style="
      width:80px;
      height:80px;
      object-fit:cover;
      border-radius:10px;
      border:1px solid #e5e7eb;
    " 
  />`
          : `
  <img src="${defaultIcon}"
    style="
      width:80px;
      height:80px;
      object-fit:cover;
      border-radius:10px;
      border:1px solid #e5e7eb;
    " 
  />`
        }

      <div>
        <div style="font-size:17px;font-weight:600;margin-bottom:3px;">
          ${n?.user?.name || '-'}
        </div>
        <div style="font-size:14px;color:#6b7280;">
          ${n?.user?.email || '-'}
        </div>

        <div style="margin-top:8px;">
          <span style="
            padding:4px 10px;
            border-radius:6px;
            font-size:12px;
            font-weight:600;
            background:#eef2ff;
            color:#4338ca;
          ">
            User ID: ${n?.user?.id}
          </span>
        </div>
      </div>
    </div>

    <!-- Subscription Details Card -->
    <div style="
      padding:15px;
      border-radius:10px;
      border:1px solid #e5e7eb;
      background:#ffffff;
      margin-bottom:20px;
    ">
      <h4 style="
        margin:0 0 15px;
        font-size:15px;
        font-weight:600;
        color:#374151;
        border-bottom:1px solid #f1f1f1;
        padding-bottom:8px;
      ">Subscription Details</h4>

      <div style="
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:12px;
      ">
        <div><strong>Plan ID:</strong> <br>${n?.plan_id}</div>
        <div><strong>Source:</strong> <br>${n?.source}</div>

        <div><strong>Start Date:</strong> <br>${n?.start_date ? format(new Date(n.start_date), "dd/MM/yyyy") : '-'}</div>
        <div><strong>End Date:</strong> <br>${n?.end_date ? format(new Date(n.end_date), "dd/MM/yyyy") : '-'}</div>

        <div><strong>Product ID:</strong> <br>${sub?.product_id || "N/A"}</div>
        <div><strong>Quantity:</strong> <br>${sub?.quantity || "N/A"}</div>

        <div><strong>Transaction ID:</strong> <br>${sub?.transaction_id || "N/A"}</div>

      </div>

      <!-- Status Badge -->
      <div style="margin-top:15px;">
        <span style="
          padding:6px 14px;
          border-radius:8px;
          font-weight:600;
          font-size:13px;
          background:${n.status === 'active' ? '#dcfce7' : '#fee2e2'};
          color:${n.status === 'active' ? '#166534' : '#b91c1c'};
          text-transform:capitalize;
        ">
          ${n?.status}
        </span>
      </div>
    </div>

    <!-- Additional Info -->
    <div style="
      padding:15px;
      border-radius:10px;
      border:1px solid #e5e7eb;
      background:#f9fafb;
    ">
      <h4 style="
        margin:0 0 10px;
        font-size:15px;
        font-weight:600;
        color:#374151;
      ">Additional Info</h4>

      <div><strong>Created At:</strong> ${format(new Date(n.created_at), "dd/MM/yyyy HH:mm")}</div>
      <div><strong>Updated At:</strong> ${format(new Date(n.updated_at), "dd/MM/yyyy HH:mm")}</div>
    </div>

  </div>
`;


      await Swal.fire({
        title: "Subscription Details",
        html: contentHtml,
        width: 550,
        heightAuto: false
      });

    } catch (e) {
      await Swal.fire({
        title: 'Error',
        text: e?.response?.data?.message || e.message || 'Failed to load subscription',
        icon: 'error',
        heightAuto: false
      });
    }
  };


  const totalPages = Math.ceil(total / perPage) || 1;

  return (
    <Card className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col><h5 className="mb-0">Subscription Management</h5></Col>
          <Col className="text-end">
            {/* <Button as={Link} to={`/news/new`} variant="primary">Create</Button> */}
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={6}>
            <Form.Control placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </Col>
          <Col md={2}>
            <Button variant="outline-secondary" onClick={() => { setPage(1); fetchData(); }}>Search</Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive hover className="align-items-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Details</th>
              <th>Plan</th>
              <th>Source</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((n, index) => (

              <tr key={n.id}>
                <td>{(page - 1) * perPage + index + 1}</td>
                <td>{n?.user?.name}<p>( {n?.user?.email} )</p></td>
                <td>{n.plan_id || '-'}</td>
                <td>{n.source || '-'}</td>
                <td>{n.start_date ? format(new Date(n.start_date), "dd/MM/yyyy") : '-'}</td>
                <td>{n.end_date ? format(new Date(n.end_date), "dd/MM/yyyy") : '-'}</td>
                <td>{n.status || ''}</td>
                <td>
                  <Button size="sm" variant="outline-info" className="me-2" onClick={() => handleView(n.id)} >View</Button>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center">{loading ? 'Loading...' : 'No data'}</td></tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center">
          <Form.Select style={{ maxWidth: 120 }} value={perPage} onChange={(e) => { setPerPage(parseInt(e.target.value, 10)); setPage(1); }}>
            {[10, 20, 50].map(n => <option key={n} value={n}>{n} / page</option>)}
          </Form.Select>
          <Pagination className="mb-0">

            {/* Prev */}
            <Pagination.Prev
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            />

            {/* Page numbers: previous */}
            {page > 1 && (
              <Pagination.Item onClick={() => setPage(page - 1)}>
                {page - 1}
              </Pagination.Item>
            )}

            {/* Active page */}
            <Pagination.Item active>{page}</Pagination.Item>

            {/* Page numbers: next */}
            {page < totalPages && (
              <Pagination.Item onClick={() => setPage(page + 1)}>
                {page + 1}
              </Pagination.Item>
            )}

            {/* Next */}
            <Pagination.Next
              disabled={page >= totalPages}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            />

          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
}